import { render, staticRenderFns } from "./DialogSelectBuilding.vue?vue&type=template&id=348a3494&scoped=true&"
import script from "./DialogSelectBuilding.vue?vue&type=script&lang=js&"
export * from "./DialogSelectBuilding.vue?vue&type=script&lang=js&"
import style0 from "./DialogSelectBuilding.vue?vue&type=style&index=0&id=348a3494&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348a3494",
  null
  
)

export default component.exports